var _defs, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Success",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.19 243.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c9e1ff;}.cls-2{fill:#00479b;}.cls-3{fill:#006aea;}.cls-4{fill:#fdfeff;}.cls-5{fill:#75b2fc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M960.86,203a12.38,12.38,0,0,0,.26-2.52,12.63,12.63,0,0,0-12.83-12.4h-.44a17.47,17.47,0,0,0-17.16-13.25,17.78,17.78,0,0,0-14.24,7,13,13,0,0,0-9.59-4.17A12.63,12.63,0,0,0,894,190.06a12.08,12.08,0,0,0,.36,2.91c-.41,0-.83-.05-1.25-.05-9.09,0-16.47,7.13-16.47,15.92,0,8.64,7.14,15.67,16,15.9a12.33,12.33,0,0,0,5.39,1.23h43.52a12.32,12.32,0,0,0,6.17-1.65,13.06,13.06,0,0,0,6.39,1.65A12.62,12.62,0,0,0,967,213.57,12.3,12.3,0,0,0,960.86,203Zm-45.33-2.52h-1.7a14.59,14.59,0,0,0,1.21-.85C915.2,199.91,915.36,200.19,915.53,200.47Z",
    transform: "translate(-628.12 -125.51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710,144.42a7.79,7.79,0,0,0,.18-1.68,8.48,8.48,0,0,0-8.62-8.33h-.29a11.75,11.75,0,0,0-11.53-8.91,12,12,0,0,0-9.56,4.71,8.72,8.72,0,0,0-6.45-2.8,8.3,8.3,0,0,0-8.38,10.28c-.27,0-.55,0-.83,0a10.69,10.69,0,1,0-.3,21.37,8.34,8.34,0,0,0,3.63.83H697a8.35,8.35,0,0,0,4.15-1.1,8.83,8.83,0,0,0,4.29,1.1,8.48,8.48,0,0,0,8.62-8.33A8.27,8.27,0,0,0,710,144.42Zm-30.44-1.68h-1.15a8,8,0,0,0,.82-.58A6.65,6.65,0,0,0,679.53,142.74Z",
    transform: "translate(-628.12 -125.51)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 188.6,
    cy: 124.43,
    rx: 113.38,
    ry: 114.39
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 174.05,
    cy: 128.91,
    rx: 113.38,
    ry: 114.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M794.13,294.71l-5,5.76a3.74,3.74,0,0,1-5.32.37l-44.43-39.19a3.83,3.83,0,0,1-.35-5.36l5-5.77a3.74,3.74,0,0,1,5.31-.36l44.43,39.18A3.83,3.83,0,0,1,794.13,294.71Z",
    transform: "translate(-628.12 -125.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M867.23,211.17h0c2.66,2.68,2.68,7-1.35,12.58a1.71,1.71,0,0,1-.22.25l-74.31,75a2,2,0,0,1-1.66.59c-1.81-.19-5.11-.6-7.29-2.81h0a7,7,0,0,1,0-9.78l75.14-75.81A6.81,6.81,0,0,1,867.23,211.17Z",
    transform: "translate(-628.12 -125.51)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M944.35,321.21c12.21-1.14,27.52,8.52,28.85,20.5.92,8.27-4.19,17.2-11.5,21.23-10.05,5.53-19.41-.88-39.05-3.51a121.75,121.75,0,0,0-37.89,1A155.42,155.42,0,0,0,918.9,339C931.38,328.66,935.19,322.07,944.35,321.21Z",
    transform: "translate(-628.12 -125.51)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M671.47,317.61c-14.07-1.31-31.7,9.81-33.23,23.62-1.06,9.52,4.82,19.81,13.25,24.45,11.57,6.37,22.35-1,45-4a140.19,140.19,0,0,1,43.65,1.18,178.82,178.82,0,0,1-39.33-24.69C686.4,326.2,682,318.6,671.47,317.61Z",
    transform: "translate(-628.12 -125.51)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 19.99,
    cy: 204.07,
    r: 19.99
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 324.65,
    cy: 230.81,
    r: 9.99
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.99,
    cy: 142.91,
    r: 9.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.6b5614b32ed267471916baf185e4b928.svg";
export { ForwardRef as ReactComponent };